var style = document.createElement("style");
style.setAttribute("less", "savage-image.less");
style.innerHTML = "savage-image * {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -ms-box-sizing: border-box;\n  box-sizing: border-box;\n}\n";
document.head.insertBefore(style, document.head.firstElementChild);
